// Module
var code = `{{#visible}}
    <div class="alert-selector">
        <terceraLabel text="{{label}}" />

        <div class="alert-selector-right">
            <accountSelector selectedItem="{{.account}}" visible="{{.visible}}" ignoreForceLinkingByAccount="true" onlyOwnAccounts="true"/>
        </div>
    </div>
{{/}}`;
// Exports
export default code;